import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";

import RemoveDialog from "./RemoveDialog";
import {
    devicesActions,
    devicesSelectedActions,
    driversActions,
    geofencesActions, groupsActions, maintenancesActions,
    notificationsActions, organizationActions, positionsActions,
    sessionActions
} from "../store";

const ConfirmHandler = ({open, endpoint, itemId, handleCloseDialog, sortedNotifications}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const storedValue = localStorage.getItem('tokenThingwings');
    const user = useSelector(state => state.session.user);

    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(null);
    const [removeAnyWayMessage, setRemoveAnyWayMessage] = useState('');

    const handleCloseSnackbar = () => {
        setOpenSnackbar(null);
    };

    const handleLogout = async () => {
        const response = await fetch('/api/session', { method: 'DELETE' });
        if (response.ok) {
            dispatch(sessionActions.updateUser(null));
            dispatch(devicesActions.refresh([]));
            dispatch(driversActions.refresh([]));
            dispatch(devicesSelectedActions.updateDevicesSelected([]));
            dispatch(geofencesActions.refresh([]));
            dispatch(groupsActions.refresh([]));
            dispatch(maintenancesActions.refresh([]));
            dispatch(notificationsActions.refreshNotifications([]));
            dispatch(organizationActions.updateOrg(null));
            dispatch(positionsActions.refresh([]));
            localStorage.clear();
            document.cookie = await 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            history.push('/login');
        }
    }

    const handleRemoveDevice = async (forceRemoveDevice) => {
        setLoading(true)
        const url = `/api/devices/device/${itemId}?removeAnyWay=${forceRemoveDevice}`;

        const header = {
            'Content-Type': 'application/json',
            'X-Auth-Token': 'Bearer ' + storedValue,
        };
        try {
            const response = await fetch(url, {
                method: 'DELETE',
                headers: header,
                body: password
            });
                setLoading(false)
            if (response.ok) {
                handleCloseDialog(true)
                if (user.subadmin)
                    dispatch(devicesActions.remove(itemId))
                else
                    setOpenSnackbar('AdminAccessRequired')
            }
            else {
                const errorText = await response.text();
                console.log(errorText.split(' ')[0])
                if (errorText.split(' ')[0] === 'checkDeviceConnection')
                    setRemoveAnyWayMessage('removeAnyWayDialog')
                setOpenSnackbar(response.status === 400 ? errorText.split(' ')[0] : 'UnknownProblem')
            }
        }
        catch (e) {
            setLoading(false)
            setOpenSnackbar('UnknownProblem')
            console.error('Fetch error:', e.message);
        }
    }

    const handleRemoveItem = async (urlUser) => {
        console.log("remove")
        console.log(urlUser)
        setLoading(true)
        const url = urlUser ? urlUser : `/api/${endpoint}/${itemId}`;
        console.log(url)
        const header = {
            'Content-Type': 'application/json',
            'X-Auth-Token': 'Bearer ' + storedValue,
        };
        try {
            const response = await fetch(url, {
                method: 'DELETE',
                headers: header,
            });
            if (response)
                setLoading(false)
            if (response.ok) {
                handleCloseDialog()
            }
            else if (response.status === 400) {
                const errorText = await response.text();
                let spliteText = errorText.split(' ')[0];
                setOpenSnackbar(spliteText)
            }
            else
                setOpenSnackbar('UnknownProblem')
        }
        catch (e) {
            setLoading(false)
            setOpenSnackbar('UnknownProblem')
            console.error('Fetch error:', e.message);
        }
    }

    const handleRemoveNots = async () => {
        // setLoading(true)
        const url = '/api/nots/deleteLastWS';
        const header = {'Content-Type': 'application/json'};

        try {
            const response = await fetch(url, {
                method: 'DELETE',
                headers: header,
                body: JSON.stringify(sortedNotifications.map(item => item.id))
            });
            // if (response)
            //     setLoading(false)
            if (response.ok) {
                handleCloseDialog()
                dispatch(notificationsActions.refreshNotifications(await response.json()))
            }
            else if (response.status === 400) {
                const errorText = await response.text();
                let spliteText = errorText.split(' ')[0];
                setOpenSnackbar(spliteText)
            }
            else
                setOpenSnackbar('UnknownProblem')
        }
        catch (e) {
            setLoading(false)
            setOpenSnackbar('UnknownProblem')
            console.error('Fetch error:', e.message);
        }
    }

    const handleRemoveAllNots = async () => {
        // setLoading(true)
        const url = '/api/nots/deleteAllWS';
        const header = {'Content-Type': 'application/json'};

        try {
            const response = await fetch(url, {
                method: 'DELETE',
                headers: header,
            });
            // if (response)
            //     setLoading(false)
            if (response.ok) {
                handleCloseDialog()
                dispatch(notificationsActions.clearNotifications());
            }
            else if (response.status === 400) {
                const errorText = await response.text();
                let spliteText = errorText.split(' ')[0];
                setOpenSnackbar(spliteText)
            }
            else
                setOpenSnackbar('UnknownProblem')
        }
        catch (e) {
            setLoading(false)
            setOpenSnackbar('UnknownProblem')
            console.error('Fetch error:', e.message);
        }
    }

    const handleOnConfirm = (forceRemoveDevice) => {
        switch (endpoint) {
            case 'exit':
                handleLogout();
                break;
            case 'devices':
                handleRemoveDevice(forceRemoveDevice);
                // handleGenericRemove(`/api/devices/${itemId}`, null, () => {
                //     dispatch(devicesActions.remove(itemId));
                // });
                break;
            case 'notificationsWS':
                handleRemoveNots();
                // handleGenericRemove('/api/devices/deleteLastWS', sortedNotifications.map(item => item.id), (data) => {
                //     dispatch(notificationsActions.refreshNotifications(data));
                // });
                break;
            case 'users':
                handleRemoveItem(`/api/${endpoint}/removeuser/${itemId}?removeAnyWay=${forceRemoveDevice}`);
                break;
            default:
                handleRemoveItem();
                break;
        }
    };

    const handleOnCloseDialog = (state) => {
        setRemoveAnyWayMessage('')
        handleCloseDialog(state)
    }


    return (
        <RemoveDialog
            open={open}
            password={password}
            setPassword={setPassword}
            loading={loading}
            openSnackbar={openSnackbar}
            endpoint={endpoint}
            onConfirm={handleOnConfirm}
            handleRemoveAllNots={handleRemoveAllNots}
            handleCloseDialog={handleOnCloseDialog}
            handleCloseSnackbar={handleCloseSnackbar}
            removeAnyWayMessage={removeAnyWayMessage}
            itemId={itemId}
        />
    );
};

export default ConfirmHandler